var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonNextUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 93,
    viewBox: "0 0 78 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button-next",
    transform: "translate(999 1028) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 39,
    cy: 39,
    r: 39,
    transform: "translate(921 935)",
    fill: "#ea8b49"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-arrow-dropdown",
    "data-name": "Icon ionic-ios-arrow-dropdown",
    transform: "translate(917.846 947.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M11.031,15.478a3.612,3.612,0,0,0,0,5.09L28.873,38.354a3.594,3.594,0,0,0,4.959.112L51.414,20.941a3.592,3.592,0,1,0-5.071-5.09l-15.1,14.878L16.121,15.46A3.6,3.6,0,0,0,11.031,15.478Z",
    transform: "translate(10.913 18.23)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M3.375,42.154A38.779,38.779,0,1,0,42.154,3.375,38.773,38.773,0,0,0,3.375,42.154ZM65.347,18.961A32.8,32.8,0,1,1,18.961,65.347,32.8,32.8,0,1,1,65.347,18.961Z",
    transform: "translate(0 0)",
    fill: "#353535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonNextUp);
export default __webpack_public_path__ + "static/media/button-next-up.4f08136c765d96f2a0dcf5b335c3f358.svg";
export { ForwardRef as ReactComponent };